import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
export default function usePatientManualRegistrationSloveniaFormValidationScheme(
	isChild: boolean,
) {
	const { t } = useTranslation();

	const validationSchema = yup.object({
		emso: yup
			.string()
			.min(13, t('validation.patientManualRegistrationSloveniaForm.emsoLength'))
			.max(13, t('validation.patientManualRegistrationSloveniaForm.emsoLength'))
			.required(t('validation.patientManualRegistrationSloveniaForm.emso')),
		salutationBefore: yup.string().notRequired().nullable(),
		salutationAfter: yup.string().notRequired().nullable(),
		firstName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.firstName')),
		lastName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.lastName')),
		address: yup.object().shape({
			street: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.street'),
				),
			descriptiveNumber: yup
				.string()
				.required(
					t(
						'validation.patientManualRegistrationCzechForm.address.descriptiveNumber',
					),
				),
			guideNumber: yup.string().notRequired().nullable(),
			city: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.city'),
				),
			postCode: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.postCode'),
				),
		}),
		healthInsuranceCompany: yup.mixed().notRequired().nullable(),
		citizenship: yup
			.mixed()
			.required(t('validation.patientManualRegistrationCzechForm.citizenship')),
		birthDate: yup
			.date()
			.typeError(
				t('validation.patientManualRegistrationHungaryForm.birthDate') ?? '',
			)
			.notRequired()
			.nullable(),
		phoneNumber: yup.string().notRequired().nullable(),
		email: isChild
			? yup
					.string()
					.email(t('validation.patientManualRegistrationCzechForm.email'))
					.notRequired()
					.nullable()
			: yup
					.string()
					.email(t('validation.patientManualRegistrationCzechForm.email'))
					.required(t('validation.patientManualRegistrationCzechForm.email')),
		healthPlanCode: yup.mixed().notRequired().nullable(),
		healthPlanWorkplaceMember: yup.mixed().notRequired().nullable(),
		legalRepresentative: isChild
			? yup.object().shape({
					firstName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
							),
						),
					lastName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
							),
						),
					email: yup
						.string()
						.email(t('validation.patientManualRegistrationCzechForm.email'))
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.email',
							),
						),
					phoneNumber: yup.string().notRequired().nullable(),
			  })
			: yup.mixed().notRequired().nullable(),
		createdByType: yup
			.object({
				value: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.createdByType'),
					),
				label: yup.string(),
			})
			.required(),
		createdById: yup.mixed().when('createdByType.value', {
			is: 'USER',
			then: yup
				.mixed()
				.required(
					t('validation.patientManualRegistrationCzechForm.createdById'),
				),
			otherwise: yup.mixed(),
		}),
	});

	return { validationSchema };
}
